export const CHANGE_LOCALE = 'app/LanguageToggle/CHANGE_LOCALE';
export const SET_LOCALE_LOCALLY = 'app/LanguageToggle/SET_LOCALE_LOCALLY';
export const SET_WORKSPACE_LOCALE_LOCALLY = 'app/LanguageToggle/SET_WORKSPACE_LOCALE_LOCALLY';
